<template>
  <div class="dialog-overlay" v-if="modalVisible">
    <div
      class="dialog bs_100"
      :style="{
        'background-image': 'url(' + imgInfo.bg_img + ')',
        width: '40rem',
        height: '34rem',
      }"
    >
      <img
        :class="`dialog-close`"
        src="@/assets/pc/popup/popup_closebutton.png"
        alt=""
        @click="close"
      />
      <img
        class="dialog-title"
        :src="imgInfo.title_img"
        alt=""
        :style="{ marginBottom: type === 1 ? '0.5rem' : '1.5rem' }"
      />
      <div class="dialog-content">
        <div
          class="rule bs_contain"
          :style="{
            'background-image': 'url(' + imgInfo.rule_img + ')',
          }"
        >
          <div v-if="type === 1" class="tipsArea">
            <span class="cdk_code"
              >{{ $t("register.tip1") }}{{ drawNumber }}</span
            >
            <span class="copy" @click="copyToClipboard">{{
              $t("prize.$3")
            }}</span>
          </div>
          <span v-else>{{ $t("register.tip2") }}</span>
        </div>
        <div class="area" :style="{ bottom: type === 1 ? '0' : '2rem' }">
          <div
            class="rule bs_contain"
            :style="{
              'background-image': 'url(' + imgInfo.rule_img + ')',
            }"
            v-if="type === 1"
          >
            <span>{{ $t("register.tip3") }}</span>
          </div>
          <div class="btn-area" v-if="type === 1">
            <div
              class="item bs_contain"
              v-for="(item, index) in imgInfo.link_list"
              :key="index"
              :style="{
                'background-image': 'url(' + item.img + ')',
              }"
              @click="openStorRegister(item.name)"
            ></div>
          </div>
          <div
            v-else
            class="btn bs_contain"
            :style="{
              'background-image': 'url(' + imgInfo.btn_img + ')',
            }"
            @click="close"
          ></div>
        </div>
      </div>
    </div>
    <div ref="copyArea"></div>
  </div>
</template>
        
        <script>
import { mapMutations, mapState } from "vuex";
import cloneDeep from "lodash/cloneDeep";
import ClipboardJS from "clipboard";
export default {
  props: {
    visible: false,
    type: {
      type: Number,
      default: 1,
    },
    cdk_code: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      modalVisible: false,
      drawNumber: "",
      hasCopy: false,
    };
  },
  watch: {
    visible: {
      handler(val) {
        this.modalVisible = val;
      },
      immediate: true,
    },
    cdk_code: {
      handler(val) {
        this.drawNumber = val;
      },
      immediate: true,
    },
  },
  computed: {
    // ...mapState(["msg", "region", "swiperEnable"]),

    imgInfo() {
      const imgObj = {
        JA: {
          title_img: require("@/assets/pc/popup/popup_title1.png"),
          bg_img:
            this.type == 1
              ? require("@/assets/pc/popup/popup_bg1.png")
              : require("@/assets/pc/popup/popup_bg2.png"),
          rule_img: require("@/assets/pc/popup/popup_edit.png"),
          item_bg: require("@/assets/pc/popup/popup_edit2.png"),
          btn_img: require("@/assets/pc/popup/popup_button_normal.png"),
          link_list: [
            {
              name: "google",
              img: require("@/assets/pc/popup/popup_download_googleplay.png"),
            },
            {
              name: "ios",
              img: require("@/assets/pc/popup/popup_download_applestore.png"),
            },
          ],
          height: this.type == 1 ? "34rem" : "26rem",
        },
      };
      return imgObj["JA"];
    },
    transformContent() {
      return (text) => {
        return text.split("\n");
      };
    },
  },
  mounted() {},
  methods: {
    ...mapMutations(["openNewMsg", "setSwiperStatus", "setSwiperActiveIndex"]),
    open() {
      this.modalVisible = true;
    },
    close() {
      // if (!this.hasCopy) {
      //   this.openNewMsg({
      //     title: this.$t("msg.title"),
      //     body: "请先点击复制您的cdk兑换码",
      //     autoClose: true,
      //     time: 1000,
      //   });
      //   return;
      // }
      this.modalVisible = false;
      this.hasCopy = false;

      this.$emit("closeModal", false);
      this.setSwiperStatus(true);
    },
    handelConfirm() {
      switch (this.type) {
        case "type1":
          this.close();
          break;

        default:
          break;
      }
    },
    openStorRegister(name) {
      this.$emit("openLink", name);
    },
    copyToClipboard() {
      const _this = this;
      // 使用一个新的 Clipboard 实例来复制文本
      const clipboard = new ClipboardJS(this.$refs.copyArea, {
        text: () => this.drawNumber,
      });

      clipboard.on("success", (e) => {
        this.openNewMsg({
          title: this.$t("msg.title"),
          body: this.$t("msg.copy_success"),
          autoClose: true,
          time: 1000,
        });
        _this.hasCopy = true;
        e.clearSelection(); // 清除高亮选择
        clipboard.destroy(); // 复制成功后释放资源
      });

      clipboard.on("error", (e) => {
        this.openNewMsg({
          title: this.$t("msg.title"),
          body: this.$t("msg.copy_fail"),
          autoClose: true,
          time: 1000,
        });
        clipboard.destroy(); // 遇到错误后释放资源
      });

      // 触发按钮的点击事件以启动复制操作
      this.$refs.copyArea.click();
    },
  },
};
</script>
    <style>
.el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
  background-color: #566567 !important;
}
</style>
    <style lang="scss" scoped>
@keyframes open_mask {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
/* 添加对话框的基本样式 */
.dialog-overlay {
  /* 样式省略，覆盖整个屏幕的半透明背景 */
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.58);
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 99999;
  animation: open_mask 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}
.dialog {
  /* 对话框样式 */
  width: 37%;
  height: 72.88%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 2.56rem;
  position: absolute;
  left: 50%;
  top: 50%;
  box-sizing: border-box;
  transform: translate(-50%, -50%);
  &-close {
    width: 2.56rem;
    height: 2.56rem;
    position: absolute;
    top: -1.45rem;
    right: -3.56rem;
    cursor: pointer;
  }

  &-title {
    width: auto;
    height: 4.5rem;
    margin-bottom: 0.5rem;
    margin-top: -0.5rem;
  }
  &-content {
    width: 100%;
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    .rule {
      width: 30rem;
      height: 2.31rem;
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        height: 1.1rem;
        line-height: 1.1rem;
        font-size: 1.1rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #ffffff;
      }
      .tipsArea {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .cdk_code {
        max-width: 75%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .copy {
        margin-left: 2rem;
        color: #ffeaac;
        text-decoration: underline;
        cursor: pointer;
      }
    }

    .area {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: center;
      position: absolute;
      left: 0;
      bottom: 0;
      .btn {
        width: 12rem;
        height: 3.88rem;
        cursor: pointer;
        &:hover {
          transform: scale(1.05);
        }
      }
      .btn-area {
        width: 100%;
        height: 3.56rem;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 1.75rem;
        .item {
          width: 12rem;
          height: 100%;
          cursor: pointer;
          &:last-child {
            margin-left: 3.5rem;
          }
          &:hover {
            transform: scale(1.05);
          }
        }
      }
    }
  }
}
</style>